import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { COMPONENT_KEY } from "../constants";
var pt = /*#__PURE__*/_defineProperty({}, COMPONENT_KEY, {
  PROFILE_LANGUAGE: 'Línguas',
  SPANISH: 'Espanhol',
  PORTUGUESE: 'Português'
});
export default pt;